import { useLocation } from '@tanstack/react-router';
import type { AnchorHTMLAttributes } from 'react';
import { cx } from './element';

/**
 * A plain link that gets Webflow's current-page markers (`w--current`, `aria-current`)
 * when it points at the page being viewed. Used in the shared header and footer.
 */
export function NavLink({ href, className, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const pathname = useLocation({ select: (l) => l.pathname });
  const current = href !== undefined && normalize(href) === normalize(pathname);
  return (
    <a
      href={href}
      className={cx(className, current && 'w--current')}
      aria-current={current ? 'page' : undefined}
      {...rest}
    />
  );
}

const normalize = (p: string) => (p.length > 1 ? p.replace(/\/$/, '') : p);
